require('./css/fonts.css');
require('./css/slick.css');
require('./sass/editor-style.scss');
require('./sass/style.scss');

require('./js/slick.js');
require('./js/vendor/modernizr-custom');
require('./js/vendor/jquery.scrollto');
require('./js/helper');
require('./js/navigation');
require('./js/maps');
require('./js/main');


// WEBPACK FOOTER //
// ./assets/app.js